import axios from '../http.js'

//查询学院树
function getCollegeTree(data) {
  return axios.baseAxios({
    url: '/backstage/question/queryCollegeTree',
    method: 'get',
    params: data
  })
}
//新增试题分类
function addQuestionCategory(data) {
  return axios.baseAxios({
    url: '/backstage/question/addQuestionCategory',
    method: 'post',
    data: data
  })
}
//删除试题分类
function delQuestionCategory(data) {
  return axios.baseAxios({
    url: '/backstage/question/deleteQuestionCategory',
    method: 'post',
    params: data
  })
}
//编辑试题分类
function editQuestionCategory(data) {
  return axios.baseAxios({
    url: '/backstage/question/editQuestionCategory',
    method: 'post',
    data: data
  })
}
//试题分类树
function getQuestionCategoryTree(data) {
  return axios.baseAxios({
    url: '/backstage/question/queryQuestionCategoryTree',
    method: 'get',
    params: data
  })
}
//-------------

//新增试题
function addQuestion(data) {
  return axios.baseAxios({
    url: '/backstage/question/createQuestion',
    method: 'post',
    data: data
  })
}
//删除试题
function delQuestion(data) {
  return axios.baseAxios({
    url: '/backstage/question/deleteQuestion',
    method: 'post',
    params: data
  })
}
//批量删除试题
function delQuestionBatch(data) {
  return axios.baseAxios({
    url: '/backstage/question/deleteQuestionBatch',
    method: 'post',
    params: data
  })
}
//编辑试题
function editQuestion(data) {
  return axios.baseAxios({
    url: '/backstage/question/editQuestion',
    method: 'post',
    data: data
  })
}
//试题详情
function getQuestionDetail(data) {
  return axios.baseAxios({
    url: '/backstage/question/queryQuestionDetail',
    method: 'post',
    params: data
  })
}
//试题分页
function getQuestionList(data) {
  return axios.baseAxios({
    url: '/backstage/question/queryQuestionPage',
    method: 'post',
    data: data
  })
}
//专业类型下拉
function getQuestionProTypeDropDown() {
  return axios.baseAxios({
    url: '/backstage/question/queryQuestionProTypeDropDown',
    method: 'get',
  })
}
function importExcel(file, belongType) {
  // 创建FormData对象并填充数据
  const formData = new FormData();
  formData.append('multipartFile', file);
  formData.append('belongType', belongType);

  // 使用axios.baseAxios发起POST请求
  return axios.baseAxios({
    url: '/backstage/question/importExcel',
    method: 'post',
    data: formData, // 直接传递formData作为请求体
    headers: { // 设置必要的请求头以适应文件上传
      'Content-Type': 'multipart/form-data'
    },
  });
}
export default {
  addQuestion,
  getCollegeTree,
  getQuestionList,
  addQuestionCategory,
  delQuestion,
  delQuestionBatch,
  delQuestionCategory,
  editQuestion,
  editQuestionCategory,
  getQuestionCategoryTree,
  getQuestionDetail,
  getQuestionProTypeDropDown,
  importExcel
}


// WEBPACK FOOTER //
// ./src/api/modules/question.js